import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';

import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';

import { provideRouter } from '@angular/router';

import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';

import { tokenInterceptor } from './auth/services/token-interceptor';

import { AuthService } from './auth/services/auth.service';

/**
 * Application-wide Angular configuration.
 * Defines the providers required to initialize and configure
 * the application, including routing, HTTP communication,
 * HTTP interceptors, global error handling, and authentication
 * session restoration.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    /**
     * Registers browser-level global error listeners for the application.
     * This allows Angular to handle and report uncaught browser
     * errors through its global error handling mechanism.
     */
    provideBrowserGlobalErrorListeners(),

    /**
     * Registers the application's route configuration.
     * Uses the routes defined in `app.routes.ts` to configure
     * Angular Router.
     */
    provideRouter(routes),

    /**
     * Configures Angular's HttpClient with the application's
     * authentication token interceptor.
     * The interceptor can modify outgoing HTTP requests,
     * such as adding authentication information.
     */
    provideHttpClient(
      withInterceptors([tokenInterceptor]),
    ),

    /**
     * Registers an application initializer that restores the
     * authenticated staff session before the application starts.
     * The initializer waits for `restoreStaffSession()` to complete
     * by converting its Observable result into a Promise.
     */
    provideAppInitializer(() =>
      firstValueFrom(
        inject(AuthService).restoreStaffSession(),
      ),
    ),
  ],
};